import React from 'react';

import { Divider, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const TOUR_OFFER_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'content-approved', label: 'Content-Approved' },
];

interface Props {
  value: string;
  onChange: (newValue?: string) => void;
}

export default function TourOfferStatusInput(props: Props) {
  const { value, onChange } = props;
  return (
    <FormControl fullWidth>
      <InputLabel>Status</InputLabel>
      <Select value={value} label="Status" onChange={(e) => onChange(e.target.value)}>
        <MenuItem value="">Any</MenuItem>
        <Divider variant="middle" />
        {TOUR_OFFER_STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
